/**
 * MUROO 심볼 — 고리를 두른 행성.
 * public/favicon.svg, public/logo-mark.svg 와 같은 도형을 쓴다.
 * 파비콘·앱 아이콘·로그인 화면이 한 모양을 공유하도록 컴포넌트로 둔다.
 */
const MurooMark = ({ size = 96, className }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 400 400"
    role="img"
    aria-label="MUROO"
    style={{ display: "block", margin: "0 auto" }}
  >
    <defs>
      <radialGradient id="muroo-body" cx="36%" cy="32%" r="78%">
        <stop offset="0%" stopColor="#b8a8e8" />
        <stop offset="42%" stopColor="#6a58bd" />
        <stop offset="78%" stopColor="#33276e" />
        <stop offset="100%" stopColor="#161038" />
      </radialGradient>
      <radialGradient id="muroo-halo" cx="50%" cy="50%" r="50%">
        <stop offset="52%" stopColor="#7b6cd4" stopOpacity="0.38" />
        <stop offset="100%" stopColor="#7b6cd4" stopOpacity="0" />
      </radialGradient>
      {/* 고리의 앞쪽 절반만 행성 위로 덮어 공전하는 느낌을 준다 */}
      <clipPath id="muroo-front">
        <rect x="-240" y="0" width="480" height="190" />
      </clipPath>
    </defs>

    <circle cx="200" cy="200" r="168" fill="url(#muroo-halo)" />

    <g transform="rotate(-18 200 200)">
      <ellipse
        cx="200" cy="200" rx="172" ry="44"
        fill="none" stroke="#c9a84c" strokeWidth="6" opacity="0.45"
      />
    </g>

    <circle cx="200" cy="200" r="100" fill="url(#muroo-body)" />
    <circle
      cx="200" cy="200" r="100"
      fill="none" stroke="#0b0820" strokeWidth="1.8" opacity="0.55"
    />

    <g transform="rotate(-18 200 200)">
      <g clipPath="url(#muroo-front)" transform="translate(200 200)">
        <ellipse
          cx="0" cy="0" rx="172" ry="44"
          fill="none" stroke="#c9a84c" strokeWidth="6" opacity="0.92"
        />
      </g>
    </g>
  </svg>
);

export default MurooMark;
